<template>
    <u-text-field-underlined v-model="modelValue" v-bind="$attrs" @input="emit" @search="$emit('search')">
        <template v-for="(_, slotName) in $slots" #[slotName]>
            <slot :name="slotName" />
        </template>
    </u-text-field-underlined>
</template>

<script>
import UTextFieldUnderlined from "@/components/publish/styles/forms/u-text-field-underlined.vue";

export default {
    components: {
        UTextFieldUnderlined,
    },
    props: {
        value: { type: String, default: null },
    },
    data: () => ({
        modelValue: null,
    }),
    methods: {
        sync() {
            this.modelValue = this.value;
        },
        emit() {
            this.$emit("input", this.modelValue);
        },
    },
    watch: {
        value() {
            this.sync();
        },
    },
    mounted() {
        this.sync();
    },
};
</script>

<style lang="scss" scoped>
.v-text-field {
    --input-border-color: var(--v-primary-base);
    --input-focused-border-color: var(--v-grey-darken4);
}
</style>
